import { inject, observer } from 'mobx-react';
import React from 'react'
import SlideItem from '../../Buttons/SlideItem';
import { v4 as uuidv4 } from 'uuid'
import ScrollArrow from '../../Inputs/ScrollArrow';
import { ReactComponent as CheckRight } from '../../../svg/chevron-right.svg'
import { ReactComponent as CheckLeft } from '../../../svg/chevron-left.svg'

@inject('elementStore', 'sidebarStore', 'workAreaStore') @observer
class ObjectSlide extends React.Component {

  constructor(props){
    super(props)
    this.state = {
      gifScrollPosition: 0,
      stickerScrollPosition: 0
    }
  }


  componentDidMount(){
    const { elementStore } = this.props
    if(elementStore.elements.length === 0){
      elementStore.findShapes()
    }
    if(elementStore.gifs.f_row.length === 0){
      elementStore.getGifs()
    }
    if(elementStore.stickers.length === 0){
      elementStore.getStickers()
    }
  }

  getObjectContent(element) {
    const { sidebarStore } = this.props
    return (
      <div 
        className='sidebar-slide__object' 
        draggable
        key={element.id} 
        onClick={() => this.handleClick(element)}
        onMouseDown={e => sidebarStore.setSelectedItem({...element, type: 'element'}, 'element', e)}
      >
        <img draggable="false" className="sidebar-slide__object__icon" src={element.dataSource}/>
      </div>
    )
  }

  getGifContent(gif, idx, vertical, row, rawGif){
    const className = vertical ? 'sidebar-slide__gif vertical' : 'sidebar-slide__gif'
    const { sidebarStore } = this.props
    return (
      <div 
        className={className} 
        key={gif.id + idx} 
        draggable
        onClick={gif.loading ? undefined : () => this.handleGifClick(gif)}
        onMouseDown={e => sidebarStore.setSelectedItem({...gif, type: 'photo', photoType: rawGif ? 'gif' : 'sticker'}, 'gif', e)}
      >
        <img 
          className={`sidebar-slide__gif__preview ${vertical ? 'vertical' : ''}`} 
          src={gif.thumbURL}
          style={{
            display: gif.loading ? 'none' : 'initial'
          }}
          draggable="false"
          onLoad={rawGif ? () => this.props.elementStore.setSingleGifLoading(gif.id, row) : () => this.props.elementStore.setStickerLoading(gif.id)}
        />
        {
          gif.loading ? (
            <div className={`sidebar-slide__gif__loading-spinner ${vertical ? 'vertical' : ''}`}>
              <img src="https://mediamodifier.com/gfx/mm-logo.svg" className='logo-loader'/>
            </div>
          )
          :
          undefined
        }
      </div>
    )
  }

  handleClick(element){
    const id = this.props.workAreaStore.insertElementToPage(element)
    this.props.workAreaStore.selectLayer(id)
  }

  handleGifClick(gif){
    if(this.props.sidebarStore.fullScreen){
      this.props.workAreaStore.setHidden(false)
      this.props.sidebarStore.toggleFullscreen()
    }
    //Set timeout until workarea is rendered again
    setTimeout(() => {
      this.insertGif(gif)
    }, 50)
  }

  insertGif(gif){
    const { originalWidth: ow, originalHeight: oh, frames: f, id, type, url } = gif
    const w = Number(ow)
    const h = Number(oh)
    const frames = Number(f)
    if(gif.loading){
      return
    }
    this.props.workAreaStore.insertPhotoToPage({
      id: uuidv4(),
      urls: {
        regular: url
      },
      height: h,
      width: w,
      xPos: 0,
      yPos: 0,
      scale: 1,
      xCrop: 0,
      yCrop: 0,
      frames,
      groupId: null,
      photoType: type,
      selected: true
    }, true)
  }

  async handleScrollLoad(stickers = false){
    if(!this.props.elementStore.gifsLoading && !stickers){
      this.props.elementStore.increaseGifPage()
      await this.props.elementStore.getGifs(this.props.sidebarStore.gifsOnly)
    }
    if(!this.props.elementStore.stickersLoading && stickers){
      this.props.elementStore.increaseStickersPage()
      await this.props.elementStore.getStickers()
    }
  }

  setGifScroll(e, sticker = false){
    let elClass = '.elements__gifs'
    if(sticker){
      elClass = '.elements__stickers'
    }
    const el = document.querySelector(elClass)
    const parent = document.querySelector('.slide-wrapper')
    const elWidth = el.scrollWidth
    const pos = el.scrollLeft + parent.clientWidth
    if(sticker){
      this.setState({
        stickerScrollPosition: e.target.scrollLeft
      })
      if(elWidth - pos < 200 && !this.props.elementStore.stickersLoading){
        this.handleScrollLoad(true)
      }
    }else{
      this.setState({
        gifScrollPosition: e.target.scrollLeft
      })
      if(elWidth - pos < 200 && !this.props.elementStore.gifsLoading){
        this.handleScrollLoad()
      }
    }
  }
  
  async setDisplay(type){
    const gifArr = []
    const { gifs, stickers } = this.props.elementStore
    gifs.f_row.forEach(g => gifArr.push(g))
    gifs.s_row.forEach(g => gifArr.push(g))
    if(type === 'gifs' && gifArr.length < 50){
      await this.props.elementStore.getFullGifs()
    }
    if(type === 'stickers' && stickers.length < 50){
      await this.props.elementStore.getFullStickers()
    }
    this.props.sidebarStore.setObjectsView(type)
    const s = document.querySelector('.sidebar-slide.gifs')
    if(s){
      setTimeout(() => {
        s.scrollTo(0, 0)
      }, 10)
    }
  }

  toggleFull(){
    if(this.props.sidebarStore.fullScreen){
      this.props.workAreaStore.setHidden(false)
    }else{
      this.props.workAreaStore.setHidden(true)
    }
    this.props.sidebarStore.toggleFullscreen()
  }
  
  unsetSingleView(){
    this.props.sidebarStore.unsetObjectsView()
    this.props.elementStore.initFullPages()
  }

  getSingleGifView(fullScreen){
    const { fullGifs, moreGifs } = this.props.elementStore
    let assets = []
    if(fullScreen){
      let idx = 0
      fullGifs.forEach(gif => {
        if(!assets[idx]){
          assets.push([])
        }
        assets[idx].push(gif)
        idx += 1
        if(idx === 4){
          idx = 0
        }
      })
    }
    return (
      <div className='elements__gifs'>
        <div className='elements__title-wrapper vertical'>
          <h5 className='elements__title vertical' onClick={() => this.unsetSingleView()}>
            <CheckLeft />GIFS
          </h5>
        </div>
          {
            fullScreen ? (
              <>
                <div className='elements__gifs__vertical-view fullscreen'>
                  {
                    assets.map(column => (
                      <div className='elements__gifs__vertical-column'>
                        {
                          column.map((g, idx) => this.getGifContent(g, idx + g.id, true, null, true))
                        }
                      </div>
                    ))
                  }
                </div>
              </>
            )
            :
            (
              <>
                {
                  fullGifs.length === 0 ?
                  (
                    <div className='elements__empty'>
                      <span>No gifs</span>
                      <label className='gray'>Try searching for something else</label>
                    </div>
                  )
                  :
                  (
                  <div className='elements__gifs vertical'>
                    {
                      fullGifs.map((g, idx) => (
                        this.getGifContent(g, idx, true, null, true)
                      ))
                    }
                  </div>
                  )
                }
              </>
            )
          }
          {
            fullGifs.length > 0 && !moreGifs ? (
              this.getEnd()
            )
            :
            undefined
          }
      </div>
    )
  }

  getSingleStickerView(fullscreen){
    const { stickers, moreStickers } = this.props.elementStore
    let assets = []
    if(fullscreen){
      let idx = 0
      stickers.forEach(gif => {
        if(!assets[idx]){
          assets.push([])
        }
        assets[idx].push(gif)
        idx += 1
        if(idx === 4){
          idx = 0
        }
      })
    }
    return (
      <div className='elements__stickers'>
        <div className='elements__title-wrapper vertical'>
          <h5 className='elements__title vertical' onClick={() => this.unsetSingleView()}>
            <CheckLeft />Stickers
          </h5>
        </div>
        {
          fullscreen ? (
            <>
              <div className='elements__stickers__vertical-view fullscreen'>
                {
                  assets.map(column => (
                    <div className='elements__stickers__vertical-column'>
                      {
                        column.map((g, idx) => this.getGifContent(g, idx + g.id, true))
                      }
                    </div>
                  ))
                }
              </div>
            </>
          )
          :
          (
            stickers.length === 0 ?
            (
              <div className='elements__empty'>
                <span>No stickers</span>
                <label className='gray'>Try searching for something else</label>
              </div>
            )
            :
            (
              <div className='elements__stickers vertical'>
                {
                  stickers.map((g, idx) => (
                    this.getGifContent(g, idx, true)
                  ))
                }
              </div>
            )
          )
        }
        {
          stickers.length > 0 && !moreStickers ? (
            this.getEnd()
          )
          :
          undefined
        }
      </div>
    )
  }

  getEnd(){
    return (
      <div 
        className='empty-result-wrapper end-results'
        style={{
          paddingBottom: '0',
          marginTop: '10px'
        }}
      >
        <span>That's it...</span>
        <label className='gray'>You've reached the end!</label>
      </div>
      )
  }

  render(){
    const { elements, gifs, stickers, moreStickers, moreGifs } = this.props.elementStore
    const { fullScreen, gifsOnly, objectsOnly, stickersOnly } = this.props.sidebarStore
    const className = fullScreen ? `elements full-screen` : `elements limited-size`
    const oneFull = gifsOnly || objectsOnly || stickersOnly
    return (
      <div 
        className="slide-wrapper"
        style={{
          paddingBottom: fullScreen ? '' : '65px'
        }}
      >
        <div className={className}>
          {
            gifsOnly ?
            (
              this.getSingleGifView(fullScreen)
            )
            :
            (
              oneFull ? undefined : (<>
                <div className='elements__title-wrapper'>
                  <h5 className='elements__title'>
                    GIFS
                    {
                      gifsOnly ? undefined : <span className='elements__title__view-all' onClick={() => this.setDisplay('gifs')}>View all</span>
                    }
                  </h5>
                </div>
                <div 
                  className='elements__gifs' 
                  onScroll={e => this.setGifScroll(e)}
                  style={{
                    minHeight: '300px'
                  }}
                >
                  <div className='elements__row'>
                    {
                      gifs.f_row.map((g, idx) => (
                        this.getGifContent(g, idx, false, 'f_row', true)
                      ))
                    }
                  </div>
                  <div className='elements__row'>
                    {
                      gifs.s_row.map((g, idx) => (
                        this.getGifContent(g, idx, false, 's_row', true)
                      ))
                    }
                  </div>
                  {
                    gifs.f_row.length === 0 && gifs.s_row.length === 0 && !moreGifs ? (
                      <div className='elements__empty'>
                        <span>No GIFS</span>
                        <label className='gray'>Try searching for something else</label>
                      </div>
                    )
                    :
                    undefined
                  }
                </div>
                </>
              )
              
            )
          }
          {
            oneFull ? undefined : (
              <ScrollArrow
                  style={{
                    top: fullScreen ? 'calc(20% - 30px)' : 'calc(26% - 30px)'
                  }}
                  loading={this.props.elementStore.gifsLoading}
                  scrollPosition={this.state.gifScrollPosition}
                  scrollClass={'elements__gifs'}
                  parentClass={'slide-wrapper'}
              />
            )
          }
          {
            stickersOnly ? (
              this.getSingleStickerView(fullScreen)
            )
            :
            (
              oneFull ? undefined :
              (
                <>
                <div className='elements__title-wrapper'>
                  <h5 className='elements__title'>
                    Stickers
                    {
                      stickersOnly ? undefined : <span className='elements__title__view-all' onClick={() => this.setDisplay('stickers')}>View all</span>
                    }
                  </h5>
                </div>
                <div 
                  className='elements__stickers' 
                  onScroll={e => this.setGifScroll(e, true)}
                  style={{
                    minHeight: '150px'
                  }}
                >
                  <div className='elements__row'>
                    {
                      stickers.map((g, idx) => (
                        this.getGifContent(g, idx)
                      ))
                    }
                  </div>
                </div>
                </>
              )
            )
          }
          {
            oneFull ? undefined : (
              <ScrollArrow
                  style={{
                    top: fullScreen ? 'calc(49% - 30px)' : 'calc(62% - 30px)'
                  }}
                  loading={this.props.elementStore.stickersLoading}
                  scrollPosition={this.state.stickerScrollPosition}
                  scrollClass={'elements__stickers'}
                  parentClass={'slide-wrapper'}
              />
            )
          }
        </div>
      </div>
    )
  }

}

/*
  {
    objectsOnly ? undefined : <span className='elements__title__view-all' onClick={() => this.setDisplay('gifs')}>View all</span>
          {
            objectsOnly ? (
              <div />
            )
            :
            (
              oneFull ? undefined :
              (
                <>
                  <div className='elements__title-wrapper'>
                    <h5 className='elements__title'>
                      Shapes
                    </h5>
                  </div>
                  <div className='elements__objects'>
                    <div className='elements__row'>
                      {
                        elements.map(el => (
                          this.getObjectContent(el)
                        ))
                      }
                    </div>
                  </div>
                </>
              )
            )
          }
  }
*/

export default ObjectSlide